// extracted by mini-css-extract-plugin
export default {"button":"ShareControl_button__9xIgI","iconBig":"ShareControl_iconBig__AGa88"};